export default __webpack_public_path__ + "static/media/lessons.574be8ea.png";